import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight, FileText } from "lucide-react";
import { toast } from "sonner";
import client, { apiErr } from "@/lib/api";
import useMeta from "@/lib/useMeta";
import { useAuth } from "@/context/AuthContext";

export default function SellerSignup() {
  const nav = useNavigate();
  const meta = useMeta();
  const { user, ready, refresh } = useAuth();
  const [form, setForm] = useState({ name: "", cat: "electronics", city: "طرابلس", phone: "", email: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  useEffect(() => {
    if (ready && user === false) nav("/auth?next=/seller-signup");
  }, [ready, user]);

  const submit = async () => {
    if (!form.name.trim() || form.phone.trim().length < 8) return toast.error("اسم النشاط ورقم هاتف صحيح مطلوبان");
    setBusy(true);
    try {
      await client.post("/merchant/apply", { name: form.name.trim(), phone: form.phone.trim(), email: form.email.trim(), city: form.city, cat: form.cat });
      await refresh();
      toast.success("تم إرسال طلبك — بانتظار التحقق");
      nav("/merchant");
    } catch (e) {
      toast.error(apiErr(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div dir="rtl">
      <div className="sticky top-0 z-20 flex items-center gap-2.5 px-3 py-3" style={{ background: "var(--k-paper)", borderBottom: "1px solid var(--k-line)" }}>
        <button data-testid="back-btn" onClick={() => nav("/")} className="k-tap w-10 h-10 rounded-full flex items-center justify-center" style={{ background: "var(--k-surface)", border: "1px solid var(--k-line)" }}><ChevronRight size={20} /></button>
        <h1 className="font-head text-[17px] font-bold">حساب تاجر جديد</h1>
      </div>

      <p className="text-[12.5px] px-4 pt-3 leading-relaxed" style={{ color: "var(--k-ink-soft)" }}>نحتاج هذه البيانات للتحقق من صاحب البضاعة قبل السماح بنشر أي منتج على المنصة.</p>

      <div className="rounded-2xl mx-4 mt-3 p-4" style={{ background: "var(--k-surface)", border: "1px solid var(--k-line)" }}>
        <label className="text-[12.5px] font-semibold block mb-1.5">اسم النشاط التجاري</label>
        <input data-testid="s-name" value={form.name} onChange={set("name")} placeholder="مثال: شركة الوادي للتجارة" className="w-full rounded-lg px-3 py-2.5 text-[13.5px] mb-3" style={{ background: "var(--k-paper)", border: "1px solid var(--k-line)" }} />
        <div className="flex gap-2.5 mb-3">
          <div className="flex-1"><label className="text-[12.5px] font-semibold block mb-1.5">نوع النشاط</label>
            <select data-testid="s-cat" value={form.cat} onChange={set("cat")} className="w-full rounded-lg px-2 py-2.5 text-[13px]" style={{ background: "var(--k-paper)", border: "1px solid var(--k-line)" }}>
              {meta.categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          <div className="flex-1"><label className="text-[12.5px] font-semibold block mb-1.5">المدينة</label>
            <select data-testid="s-city" value={form.city} onChange={set("city")} className="w-full rounded-lg px-2 py-2.5 text-[13px]" style={{ background: "var(--k-paper)", border: "1px solid var(--k-line)" }}>
              {meta.cities.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
        </div>
        <label className="text-[12.5px] font-semibold block mb-1.5">رقم الهاتف</label>
        <input data-testid="s-phone" value={form.phone} onChange={set("phone")} type="tel" placeholder="+218 9x xxx xxxx" className="w-full rounded-lg px-3 py-2.5 text-[13.5px] mb-3" style={{ background: "var(--k-paper)", border: "1px solid var(--k-line)" }} />
        <label className="text-[12.5px] font-semibold block mb-1.5">البريد الإلكتروني (اختياري)</label>
        <input data-testid="s-email" value={form.email} onChange={set("email")} type="email" placeholder="name@business.com" className="w-full rounded-lg px-3 py-2.5 text-[13.5px] mb-3" style={{ background: "var(--k-paper)", border: "1px solid var(--k-line)" }} />

        <button type="button" onClick={() => toast("رفع المستندات غير مفعّل في هذا النموذج التجريبي")} className="k-tap flex items-center justify-center gap-2 w-full py-2.5 rounded-lg text-[12.5px] mb-2" style={{ border: "1px dashed var(--k-line)", color: "var(--k-ink-soft)" }}>
          <FileText size={14} /> إرفاق وثيقة إثبات النشاط (قريبًا)
        </button>
        <p className="text-[11px] mb-4 leading-relaxed" style={{ color: "var(--k-ink-soft)" }}>بعد الإرسال، سيراجع فريقنا طلبك. لن تظهر منتجاتك للمشترين قبل التحقق.</p>
        <button data-testid="seller-submit" disabled={busy} onClick={submit} className="k-tap w-full py-3.5 rounded-2xl font-bold text-[14.5px] text-white" style={{ background: "var(--k-ink)", opacity: busy ? 0.7 : 1 }}>إرسال للتحقق</button>
      </div>
    </div>
  );
}
